export const aboutData = {
    title: 'О нас',
    head: '4 people российская   IT-компания',
    description: '4 people — российская IT-компания. Мы разрабатываем ПО под ключ, автоматизируем бизнес-процессы, сопровождаем и дорабатываем готовые продукты. Решаем задачи любой сложности, ориентируясь на специфику клиента. Поэтапная разработка снижает затраты на старте, а прибыль приходит сразу после запуска. Цена зависит от требований и сложности, работаем прозрачно и гибко.',
    list: [
        'Языки программирования: Kotlin, PHP, C++, C#, Python',
        'Frontend: HTML, CSS, JS, Vue 3',
        'Android библиотеки и фреймворки: Coroutines, Compose, Retrofit, JUnit5, Kaspresso, Room, Glide, Cicerone, Dagger 2, ViewModel',
        'Базы данных: MySQL, ClickHouse',
        'Коды ИТ-деятельности: 1.01, 1.05, 1.06, 4.01, 9.01',
    ],
};
